import React from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
type KeyType = 'Create' | 'Edit';

const keys: Record<KeyType, string> = {
    Create : 'Create Day wise Plan',
    Edit : 'Edit Day wise Plan'
};

function DaywiseCard() {
  const location = useLocation();
  const navigate = useNavigate();

const datas : KeyType[] = ["Create", "Edit"]
  const navigateFunction = (key: KeyType) => {
      if (key=="Create"){
        navigate('/admin/batch-calendar');
      }
      else if (key=="Edit"){
        navigate('/admin/edit-batch');

      }


  }
  return (
  <div className="container mt-4">
    <div className="row g-4 d-flex justify-content-center align-items-center">
      {datas.map((key) =>
        keys[key] ? (
          <div key={key} className="col-md-4" role="button" onClick={()=>navigateFunction(key)}>
            <div style={{height:"400px"}} className="d-flex justify-content-center align-items-center card shadow-sm border-primary">
              
                <h5 className="px-2 card-title text-primary">{keys[key]}</h5>
           
            </div>
          </div>
        ) : null
      )}
    </div>
 </div>
  );
}

export default DaywiseCard;
